var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Slices',{attrs:{"slices":_vm.document.data.body}}),_vm._v(" "),_c('AuthorityBox',{attrs:{"document":_vm.document,"hreflangs":_vm.hreflangs}}),_vm._v(" "),_c('script',{attrs:{"type":"application/ld+json"},domProps:{"innerHTML":_vm._s(_vm.jsonld)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }